module.exports = __webpack_public_path__ + "static/media/logoPortimar.3fa8b789.png";